export default {
  nodes: [], // All data considering food web nodes
  links: [], // All data considering food web links between nodes
}
